export const columns = [
  { accessorKey: "vehicleNumber", header: "Vehicle", flex: 1 },
  { accessorKey: "assignedFrom", header: "Assigned From", flex: 1 },
  { accessorKey: "notes", header: "Remarks", flex: 1 },
  { accessorKey: "assignto", header: "Assign To", flex: 1 },
  {
    accessorKey: "action",
    header: "Action",
    flex: 1,
    accessorFn: (row: any) => ` ${row.action || " "}`,
  },
];
